export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';

export const forgotPasswordSuccess = () => ({
    type: FORGOT_PASSWORD_SUCCESS,
});
